// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-toolbar {
  padding-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ax-project-selector/ax-project-selector.component.scss"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ","sourcesContent":[":host {\n  ion-toolbar {\n    padding-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
